.dx{aspect-ratio:1/1;}